import React, { useState } from 'react'
import { EntryPage, SignUpForm, SignUpEmailForm, SignInSSO, useTenant, NavBar as PublicNavBar, getErrorMessage } from '@emerald-works-nova/auth'
import { Auth } from '@aws-amplify/auth'
import { useSelector, useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { Grid } from '@mui/material'
import UserRegistrationSlice from '../../reducers/user-registration'
import { routes } from './../../routes'

const Register = () => {
  const tenant = useTenant()
  const dispatch = useDispatch()

  const [isRegistering, setIsRegistering] = useState(false)
  const [error, setError] = useState({ isError: false, message: null })
  const [isValid, setIsValid] = useState(false)
  const defaultValues = useSelector(UserRegistrationSlice.selectors.selectSingUpInfo)

  const [checkEmailRegistration] = useEvent([{
    eventName: 'userEmailChecker',
    onSuccess: (payload) => {
      dispatch(UserRegistrationSlice.actions.setSignUpInfo({ email: payload.email }))
      setIsValid(payload.valid)
    },
    onError: () => {
      setError({ isError: true, message: 'Unable to check email' })
    }
  }])

  const handleValidateEmail = async (event) => {
    event.preventDefault()
    checkEmailRegistration.trigger({ email: event.target.email.value, userPoolId: tenant.userPoolId })
  }

  const handleSignUp = async (data) => {
    dispatch(UserRegistrationSlice.actions.setSignUpInfo(data))
    setIsRegistering(true)

    try {
      const { firstName, lastName, email, password } = data
      const username = uuidv4()

      const verifyUrl = window.location.href.match(/\/\/(?<base>.+)\//).groups.base

      await Auth.signUp({
        username,
        password,
        attributes: {
          email,
          given_name: firstName,
          family_name: lastName
        },
        clientMetadata: {
          verifyUrl,
          application: process.env.REACT_APP_APPLICATION_NAME
        }
      })
      await Auth.signIn({ username: email, password })
      setTimeout(() => {
        location.href = `${process.env.PUBLIC_URL}/`
      }, 5000)
    } catch (error) {
      setError({ isError: true, message: getErrorMessage(error) })
    } finally {
      setIsRegistering(false)
    }
  }

  const resetEmail = (data) => {
    dispatch(UserRegistrationSlice.actions.setSignUpInfo({ ...data, email: '', password: '' }))
  }

  return (
    <Grid
      container
      direction='column'
      wrap='nowrap'
    >
      <Grid item style={{ minHeight: 85 }}>
        <PublicNavBar
          captionText='Already have an account?'
          link={routes.login.path}
          buttonText='Sign in'
        />
      </Grid>
      <Grid item>
        <EntryPage
          title='Sign up'
          subtitle={!defaultValues.email && !checkEmailRegistration.isWorking && 'First, enter your email address below.'}
          showMtLogo
          content={defaultValues.email
            ? (
              <SignUpForm
                onSignUp={handleSignUp}
                emailIsValid={isValid}
                error={error}
                setError={setError}
                isSaving={isRegistering}
                email={defaultValues.email}
                resetEmail={resetEmail}
                defaultValues={defaultValues}
              />
            ) : (
              <SignUpEmailForm
                onSubmit={handleValidateEmail}
                loading={checkEmailRegistration.isWorking}
                error={error}
              />)}
          sso={!defaultValues.email &&
            <SignInSSO
              loginProviders={tenant.loginProviders}
              text='&nbsp;&nbsp;Or'
            />}
          application={process.env.REACT_APP_APPLICATION_NAME}
        />
      </Grid>
    </Grid>
  )
}

export default Register
